/**
 * TanStack Router: /performance/objetivos-individuais/detail
 *
 * Component: OKRDetailPage
 * Layout: Authenticated (_auth)
 *
 * Focus mode detail view for individual OKR objectives.
 * Expects `id` search param with the OKR ID.
 */
import { createFileRoute } from '@tanstack/react-router'
import OKRDetailPage from '@/app/performance/objetivos-individuais/detail/page'

export const Route = createFileRoute('/_auth/performance/objetivos-individuais/detail')({
  component: OKRDetailPage,
})
